module.exports = __webpack_public_path__ + "static/media/cate-coffee.c52eadd0.png";